"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutPartSchema = void 0;
const zod_1 = require("zod");
exports.LayoutPartSchema = zod_1.z.enum([
    'TITLE',
    'SUBTITLE1',
    'SUBTITLE2',
    'BODYTEXT1',
    'BODYTEXT2',
    'IMAGE1',
    'IMAGE2',
    'ANSWER_AREA',
    'VIDEO',
]);
//# sourceMappingURL=layout-part.js.map